import { render, staticRenderFns } from "./Ticketing.vue?vue&type=template&id=5b10d684&scoped=true&"
import script from "./Ticketing.vue?vue&type=script&lang=js&"
export * from "./Ticketing.vue?vue&type=script&lang=js&"
import style0 from "./Ticketing.vue?vue&type=style&index=0&id=5b10d684&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10d684",
  null
  
)

export default component.exports